module.exports = __webpack_public_path__ + "static/media/courseMain.48e5d255.png";